import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@anonymizePro/components/ui/carousel';
import { featureContent } from '@anonymizePro/mock/contents';
import React from 'react';
import ImageRenderer from '@app/components/media-renderer/image-renderer';

export default function SwiperLayout() {
    return (
        <div className="relative h-full min-h-screen w-full bg-gradient-to-b from-blue-200 to-red-200">
            <div className={'mx-auto my-20 h-full w-[75%] '}>
                <Carousel>
                    <CarouselContent>
                        {featureContent.map((f) => {
                            return (
                                <CarouselItem key={f.step}>
                                    <div className={'flex w-full flex-col justify-center '}>
                                        <ImageRenderer media={f.image} isGrayScale={false} />
                                        <div className={'anonymize-h4 mt-10 text-black-600'}>STEP {f.step}</div>
                                        <div className={'anonymize-h2 mt-2 text-black-800'}>{f.title}</div>
                                        <div className={'anonymize-p4 font-normal text-black-700'}>{f.description}</div>
                                    </div>
                                </CarouselItem>
                            );
                        })}
                    </CarouselContent>
                    <div className="flex h-full justify-between">
                        <CarouselPrevious />
                        <CarouselNext />
                    </div>
                </Carousel>
            </div>
        </div>
    );
}
